/**
 * Inline confirm dialog rendered below a SquadBanner when the operator
 * clicks "Recall". Copy per cycle-2 UX F4 — explicitly warns that
 * synth WON'T fire and the in-flight LLM calls still bill.
 */
import React from 'react';
import type { Squad, SquadMember } from '../../types/squads';


interface Props {
  squad: Squad;
  members: SquadMember[];
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
}


export const SquadRecallConfirm: React.FC<Props> = ({ members, onConfirm, onCancel }) => {
  const inFlight = members.filter(
    (m) => m.status === 'running' || m.status === 'dispatched',
  );
  const done = members.filter((m) => m.status === 'done').length;
  return (
    <div
      className="border-t border-slate-200 dark:border-slate-700 px-2 py-1
                 bg-amber-50 dark:bg-amber-900/20"
    >
      <div className="text-xs text-slate-700 dark:text-slate-200">
        ▶ Recall? Trailmaster WON'T synthesize. You'll see partial results
        from {done} of {members.length} member{members.length === 1 ? '' : 's'}
        {inFlight.length > 0 && (
          <> (the {inFlight.length} in flight finish their current LLM call
          and bill, then stop)</>
        )}
        .
      </div>
      <div className="flex justify-end gap-2 mt-1">
        <button
          onClick={() => void onConfirm()}
          className="bg-rose-500 hover:bg-rose-600 text-white px-2 py-0.5
                     rounded text-xs"
        >
          Yes, recall
        </button>
        <button
          onClick={onCancel}
          className="bg-slate-200 hover:bg-slate-300 dark:bg-slate-700
                     dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200
                     px-2 py-0.5 rounded text-xs"
        >
          Keep running
        </button>
      </div>
    </div>
  );
};
